import { categories, kaspreadsheetUrl } from "@/mocks/categories";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="relative bg-foreground-950 rounded-t-[32px] mx-4 md:mx-6 mt-16 overflow-hidden">
      <div className="relative z-10 px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
          <div className="lg:col-span-1">
            <h3 className="text-white text-2xl font-extrabold font-heading mb-6">
              Hoobuy Sheet
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6 max-w-xs">
              O hub oficial do <strong className="text-foreground-200">hoobuyspreadsheet</strong> atualizado 2026.
              Lista completa de produtos virais organizados por categoria.
            </p>
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-accent-400 text-sm font-medium hover:text-accent-300 transition-colors whitespace-nowrap"
            >
              Acessar Hoobuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold font-heading mb-5 uppercase tracking-wider">
              Categorias
            </h4>
            <ul className="space-y-3">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-sm hover:text-white transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold font-heading mb-5 uppercase tracking-wider">
              Mais Categorias
            </h4>
            <ul className="space-y-3">
              {categories.slice(7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-400 text-sm hover:text-white transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold font-heading mb-5 uppercase tracking-wider">
              Links Úteis
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/"
                  className="text-foreground-400 text-sm hover:text-white transition-colors"
                >
                  Início
                </a>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => navigate("/artigo/guia-completo-hoobuyspreadsheet")}
                  className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  Guia Completo
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => navigate("/artigo/guia-compras-hoobuy-iniciantes")}
                  className="text-foreground-400 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  Guia de Compras
                </button>
              </li>
              <li>
                <a
                  href={kaspreadsheetUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-400 text-sm hover:text-white transition-colors"
                >
                  Hoobuy Sheet
                </a>
              </li>
              <li>
                <a
                  href={kaspreadsheetUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-400 text-sm hover:text-white transition-colors"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} hoobuy.biz — Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-4">
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors"
            >
              Privacidade
            </a>
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors"
            >
              Termos
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pointer-events-none select-none overflow-hidden">
        <p className="text-[120px] md:text-[180px] font-extrabold text-foreground-800/10 leading-none tracking-tighter text-center whitespace-nowrap">
          HOOBUY
        </p>
      </div>
    </footer>
  );
}